<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">


  <kendo-grid
    [kendoGridBinding]="gridView"
    kendoGridSelectBy="invoiceNumber"
    [kendoGridSelectBy]="selectedCallback"
    [(selectedKeys)]="mySelection"
    [selectable]="{enabled: true, checkboxOnly: true }"
    [filterable]="true"
    [resizable]="true"
    [sortable]="true"
    [scrollable]="true"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    (dataStateChange)="dataStateChange($event)"
    [filter]="filter"
    [filterable]="true"
    (filterChange)="filterChange($event)"
    (selectAllChange)="onSelectAllChange($event)"
    [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
    style="height: 80vh">
      
    <ng-template kendoGridToolbarTemplate>

        <!-- <div fxLayout="row" gdColumns="50% 50%" fxLayoutGap="10px" fxLayoutAlign=" stretch"> -->

          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch">

            <div>Hierarchy
              <kendo-dropdownlist
                [data]="hierarchyList"
                [textField]="'key'"
                [valueField]="'key'"
                [(ngModel)]="selectedHierarchy"
                (valueChange)="hierarchyValueChange($event)"
                name="selectedHierarchy">
              </kendo-dropdownlist>
            </div>

            <div>Type
              <kendo-dropdownlist
                [data]="typeList"
                [(ngModel)]="selectedType"
                (valueChange)="typeValueChange($event)"
                name="selectedType">
              </kendo-dropdownlist>
            </div>
          </div>    
          
          <div>
            
            <input id="selectAllCheckId"
                   type="checkbox"
                   kendoCheckBox
                   kendoGridSelectAllCheckbox
                   [state]="selectAllRecordState"
                   (selectAllChange)="onSelectAllRecordChange($event)">
            <label  for="selectAllCheckId">All Records</label>
          </div>
          <div class="gl-print-btns" fxFlex fxLayout="row" fxLayoutAlign="end end">
            <app-mcl-button text="Export Selected Invoices" primary="true" type ="button" (click)="exportClicked()" style="float: right;">
            </app-mcl-button>
          </div>

        <!-- </div> -->
    </ng-template>


    <!-- <kendo-grid-checkbox-column
      [width]="45"
      [headerClass]="{'text-center': true}"
      [class]="{'text-center': true}"
      [resizable]="false"
      [columnMenu]="false"
      showSelectAll="true"
    ></kendo-grid-checkbox-column> -->



    <kendo-grid-checkbox-column
      [width]="100"
      [headerClass]="{'text-center': true}"
      [class]="{'text-center': true}"
      [resizable]="false"
      [columnMenu]="false"
      showSelectAll="true">
      <ng-template >
        <input 
               type="checkbox"
               kendoGridSelectAllCheckbox
               class="k-checkbox" 
               id="selectAllCheckboxId" 
               [state]="selectAllState"
               (selectAllChange)="onSelectAllChange($event)"/>
        <label  class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
      </ng-template>
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="invoiceNumber" title="Invoice Number" filterable="true" [width]="250">
      <ng-template kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
        <p *ngIf="gridData">
          {{mySelection.length}} invoice(s) selected out of {{gridView.total}} </p>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="storeId" title="Store Number" filterable="true" [width]="250"></kendo-grid-column>

    <kendo-grid-column field="invoiceDate" type='date' title="Invoice Date" format="yyyy-MM-dd"
                       [width]="300">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <date-range-filter-cell
          class="date-range-filter"
          [filter]="filter"
          field="invoiceDate">
        </date-range-filter-cell>
      </ng-template>

    </kendo-grid-column>

    <kendo-grid-column field="discountDate" title="Discount Date" filterable='true' format="yyyy-MM-dd" [width]="300">

      <ng-template kendoGridFilterCellTemplate let-filter>
        <date-range-filter-cell
          class="date-range-filter"
          [filter]="filter"
          field="discountDate">
        </date-range-filter-cell>
      </ng-template>

    </kendo-grid-column>

    <kendo-grid-column field="invoiceTotal" title="Invoice Total" filterable="true" [width]="250">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.invoiceTotal | currency}}
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
<div kendoDialogContainer></div>

